import { checkIfEmailIsAvailable, checkIfEmailIsInUse } from 'pages/utils';
import { getValidationMessage } from './messages';

export const validateDateOfBirth = (dateOfBirthdayValue: unknown) => {
    if (dateOfBirthdayValue === '' || dateOfBirthdayValue === null || dateOfBirthdayValue === undefined || dateOfBirthdayValue === false || dateOfBirthdayValue === 'Invalid date') {
        return getValidationMessage().mandatoryError;
    }
    const regex = /^\d{2}.\d{2}.\d{4}$/;

    if (!regex.test(String(dateOfBirthdayValue))) return getValidationMessage().notBirthDateError;
    const splitDateOfBirthday = typeof dateOfBirthdayValue === 'string' ? dateOfBirthdayValue?.split('/') : null;

    if (splitDateOfBirthday && (+splitDateOfBirthday[2] < 1900)) return getValidationMessage().birthDateError;

    return null;
};

export const validateInputString = (inputValue: unknown) => (
    inputValue === null || inputValue === undefined || inputValue === 'N.A' || inputValue === '' ? getValidationMessage().mandatoryError : null
);

export const validateInputAlphanumeric = (inputValue: unknown, isRequired = false) => {
    if (isRequired) {
        const isInvalidString = validateInputString(inputValue);

        if (isInvalidString) return isInvalidString;
    }
    if (!inputValue || inputValue === '') return null;

    return inputValue.toString().match(/^\w+$/) ? null : getValidationMessage().alphanumericError;
};

export const validateName = (inputValue: string) => {
    if (inputValue === null || inputValue === undefined || inputValue === 'N.A' || inputValue === '') return getValidationMessage().mandatoryError;
    const nameValidationRegExp = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;

    return nameValidationRegExp.test(inputValue) ? null : getValidationMessage().nameError;
};

export const validateInputNumber = (inputNumberValue: unknown) => {
    if (inputNumberValue === null || inputNumberValue === undefined) return getValidationMessage().mandatoryError;

    return /^[0-9]+$/.test(String(inputNumberValue)) ? null : getValidationMessage().numberError;
};

export const validateInputNumberWithZero = (inputNumberValue: unknown) => (inputNumberValue === 0 ? getValidationMessage().mandatoryError : validateInputNumber(inputNumberValue));
export function escapeRegExCharacters(value: string) { return value.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&'); }

export const validateEmailAdress = (emailAdressValue: unknown) => {
    if (emailAdressValue === null || emailAdressValue === undefined || emailAdressValue === 'N.A') return getValidationMessage().mandatoryError;
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const customRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

    return (!regex.test(String(emailAdressValue)) || !customRegex.test(String(emailAdressValue))) ? getValidationMessage().emailError : null;
};

export const validateEmailAddressUniqueness = async (email: string, userRegisterId?: string) => {
    const isEmailInUse = userRegisterId ? await checkIfEmailIsInUse(userRegisterId, email) : !(await checkIfEmailIsAvailable(email));

    return isEmailInUse ? getValidationMessage().emailInUse : null;
};

export const validatePhoneNumber = (phoneNumberValue: string, required = true) => {
    if (required && (phoneNumberValue === null || phoneNumberValue === undefined)) return getValidationMessage().mandatoryError;
    const regex = new RegExp('^[\\+][(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,7}$');

    return phoneNumberValue && !regex.test(phoneNumberValue) ? getValidationMessage().phoneError : null;
};

export const validateSelect = (selectValue: unknown) => (selectValue === null || selectValue === undefined || selectValue === 'N/A' ? getValidationMessage().mandatoryError : null);
export const validateRadio = (radioValue: unknown) => (radioValue === null || radioValue === undefined ? getValidationMessage().mandatoryError : null);
export const validateInputLength = (value: { length?: number }, maxAllowed = 40) => (value?.length && value?.length > maxAllowed ? getValidationMessage({ length: maxAllowed }).lengthError : null);

export const validateMultipleInputsLength = (maxAllowed: number, message: string, ...args: Array<{ length?: number }>) => {
    let totalLength = 0;

    args.forEach((f) => { totalLength += f?.length || 0; });

    return totalLength > maxAllowed ? message : null;
};

export const IsAllDataNull = (obj: Record<string, unknown>) => Object?.values(obj)?.every((value) => value == null);
export const IsAllDataFalse = (obj: Record<string, unknown>) => Object.values(obj).every((value) => !value);
